import equaliseProductHeights from './equalise-product-heights';
import removeEmptyTags from './remove-empty-deal-tags';

const loadingSpinner = document.querySelector(
    '[data-filters-role="state-classes"]'
);
const loaderDealsContainer = document.querySelector(
    '[data-results-container]'
);
const loadMoreDealsButton = document.querySelector(
    '[data-filters-action="load-more-deals"]'
);

const prepareLoading = () => {
    const pageState = parseInt(loadMoreDealsButton.dataset.pageState);
    loadMoreDealsButton.dataset.pageState = pageState + 1;
    loadMoreDealsButton.classList.add('hide');
    loadingSpinner.classList.add('filter-state-loading');
    loadingSpinner.classList.remove('filter-state-paginating');
};

const insertLoadedDeals = (deals) => {
    loaderDealsContainer.insertAdjacentHTML('beforeend', deals);
    loadingSpinner.classList.remove('filter-state-loading');
    setTimeout(() => [equaliseProductHeights, removeEmptyTags, initAccordions]
        .forEach(fn => typeof fn === 'function' && fn()), 0);
};

const continueLoading = () => {
    loadMoreDealsButton.classList.remove('hide');
    loadingSpinner.classList.add('filter-state-paginating');
};

const loadDeals = () => {
    const pageState = loadMoreDealsButton.dataset.pageState;
    const url = new URL(document.URL);
    url.searchParams.append('page', pageState);
    url.searchParams.append('filtersUpdated', false);

    fetch(url, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    })
        .then(res => res.json())
        .then((data) => {
            const resultsRoot =
                loaderDealsContainer ||
                document.querySelector('[data-results-container]');

            const cardSelector = '.focus-product-wrap';
            const titleSelector = '.focus-product-main .focus-title-load-more';

            const oldCount = resultsRoot
                ? resultsRoot.querySelectorAll(cardSelector).length
                : 0;

            insertLoadedDeals(data.listing.deals);

            const allCards = resultsRoot.querySelectorAll(cardSelector);
            const firstNew = allCards[oldCount];

            if (!firstNew) {
                return;
            }

            const firstTitle = firstNew.querySelector(titleSelector);

            if (!firstTitle) {
                return;
            }

            const hadTabindex = firstTitle.hasAttribute('tabindex');

            if (!hadTabindex) {
                firstTitle.setAttribute('tabindex', '-1');
            }

            firstTitle.focus();

            if (!hadTabindex) {
                setTimeout(() => {
                    firstTitle.removeAttribute('tabindex');
                }, 300);
            }

            if (data.listing.islastpage) {
                destroyLoader();
            } else {
                continueLoading();
            }
            reloadFeefoScript();
        });
};

const reloadFeefoScript = () => {
    const old = document.querySelector('script[src*="feefo.com/api/javascript"]');
    if (old) {
        old.remove();
    }
    const s = document.createElement('script');
    s.src = 'https://api.feefo.com/api/javascript/carphone-warehouse';
    s.async = true;
    document.body.appendChild(s);
};

const loadMoreDeals = (event) => {
    event.preventDefault();
    prepareLoading();
    loadDeals();
};

const destroyLoader = () => {
    loadingSpinner.classList.add('filter-state-pagination-finished');
};

const init = () => {
    if (loadMoreDealsButton) {
        loadMoreDealsButton.addEventListener('click', loadMoreDeals);
    }
};

export default init;
